import _fails from "../internals/fails";
import _isCallable from "../internals/is-callable";
import _isObject from "../internals/is-object";
import _objectCreate from "../internals/object-create";
import _objectGetPrototypeOf from "../internals/object-get-prototype-of";
import _defineBuiltIn from "../internals/define-built-in";
import _wellKnownSymbol from "../internals/well-known-symbol";
import _isPure from "../internals/is-pure";
var exports = {};
var fails = _fails;
var isCallable = _isCallable;
var isObject = _isObject;
var create = _objectCreate;
var getPrototypeOf = _objectGetPrototypeOf;
var defineBuiltIn = _defineBuiltIn;
var wellKnownSymbol = _wellKnownSymbol;
var IS_PURE = _isPure;
var ITERATOR = wellKnownSymbol("iterator");
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!("next" in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}
var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype) || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});
if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  defineBuiltIn(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}
exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};
export default exports;